import { routes } from "consts";

// Every API request must name its tenant. vite.config.js fails a production build without
// VITE_TENANT_ID, so a missing value here means a misconfigured local or non-production build.
const tenantId = import.meta.env.VITE_TENANT_ID;
if (!tenantId) {
  console.error(
    "[tenant] VITE_TENANT_ID is not set: the API will reject every request (400, missing X-Tenant-Id). " +
      "Set it in admin-ui/.env (local) or in the Netlify site env, then rebuild.",
  );
}

export const onRequestFulfilled = async (config: any) => {
  const accessToken = localStorage.getItem("api_token");
  if (accessToken) {
    config.headers = {
      ...config.headers,
      authorization: `Bearer ${accessToken}`,
    };
  }

  config.headers = {
    ...config.headers,
    "X-Tenant-Id": tenantId,
  };

  return config;
};

export const dateConvertinterceptor = (originalResponse: any) => {
  if (originalResponse?.status === 401) {
    window.location.href = routes.LOGIN;
    window.location.reload();
  }
  handleDates(originalResponse.data);
  return originalResponse;
};

const isoDateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?$/;

function isIsoDateString(value: any): boolean {
  return value && typeof value === "string" && isoDateFormat.test(value);
}

export function handleDates(body: any) {
  if (body === null || body === undefined || typeof body !== "object") return body;

  for (const key of Object.keys(body)) {
    const value = body[key];
    if (isIsoDateString(value)) body[key] = new Date(value);
    else if (typeof value === "object") handleDates(value);
  }
}
